"use strict";

exports.__esModule = true;
exports.makeRoute = makeRoute;
exports.makeUrls = makeUrls;
exports.matchRoute = matchRoute;

var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function makeRoute(_ref) {
  var page = _ref.page,
      _ref$pattern = _ref.pattern,
      pattern = _ref$pattern === void 0 ? page : _ref$pattern,
      rest = _objectWithoutPropertiesLoose(_ref, ["page", "pattern"]);

  if (typeof page !== "string") {
    throw new TypeError("Expected 'page' to be a string, but got: " + page);
  } // These functions aren’t created until they are used for the first time.


  var _match = undefined;
  var _reverse = undefined;
  return _extends({
    page: page,
    pattern: pattern,
    match: function match(pathname) {
      if (_match == null) {
        _match = makeMatchFunction(pattern);
      }

      return _match(pathname);
    },
    reverse: function reverse(params) {
      if (_reverse == null) {
        _reverse = _pathToRegexp.default.compile(pattern);
      }

      return _reverse(params);
    }
  }, rest);
}

function makeMatchFunction(pattern) {
  var keys = [];
  var regex = (0, _pathToRegexp.default)(pattern, keys, {
    // Just like standard Next.js, don’t allow trailing slashes.
    strict: true,
    // Just like standard Next.js, URLs are case sensitive.
    sensitive: true
  });
  return function (pathname) {
    var match = regex.exec(pathname);

    if (match == null) {
      return undefined;
    }

    return match.slice(1).reduce(function (result, value, index) {
      var key = keys[index]; // Later params with the same name overwrite earlier ones. We _could_ make
      // an array with all values, but it is not possible to pass an array of
      // values when reversing the URL, so to be consistent we must only allow
      // one value per param name (unless the param is repeatable).

      result[key.name] = key.repeat && value != null ? value.split(key.delimiter) : value;
      return result;
    }, Object.create(null));
  };
}

function makeUrls(_ref2) {
  var route = _ref2.route,
      _ref2$params = _ref2.params,
      params = _ref2$params === void 0 ? {} : _ref2$params,
      _ref2$query = _ref2.query,
      query = _ref2$query === void 0 ? {} : _ref2$query,
      _ref2$hash = _ref2.hash,
      hash = _ref2$hash === void 0 ? "" : _ref2$hash;
  return {
    href: {
      pathname: route.page,
      query: _extends({}, query, params)
    },
    as: {
      pathname: route.reverse(params),
      query: query,
      hash: hash
    }
  };
}

function matchRoute(routes, pathname) {
  for (var index = 0; index < routes.length; index++) {
    var route = routes[index];
    var match = route.match(pathname);

    if (match != null) {
      return {
        route: route,
        params: match
      };
    }
  }

  return undefined;
}